module.exports = {
  'en': {
    'HRES32EC1': {
      '5': 'Start Request Date',
      '7': 'To',
      '10': 'Request Date',
      '20': 'Type Of Change',
      '25': 'Seq. No.',
      '30': 'Status',
      '40': 'Remark',
      '50': 'Approve by',
      '60': 'Employee Name',
      '70': 'Personal Data',
      '80': 'Education Data',
      '90': 'Children Data',
      '100': 'Honour"s Info',
      '110': 'Training Record',
      '120': 'Request Date',
      '140': 'Next Step Approver'
    },
    'HRES32EC10': {
      '10': 'No.',
      '20': 'Children "s Name',
      '30': 'Birth Date',
      '40': 'Gender',
      '50': 'Education Level',
      '60': 'Data Status'
    },
    'HRES32EC11': {
      '10': 'Type of Award',
      '20': 'Description',
      '30': 'Refer Doc. No.'
    },
    'HRES32EC12': {
      '10': 'Education Data',
      '20': 'Sequence No.',
      '30': 'Education Level',
      '40': 'Degree',
      '50': 'Major',
      '60': 'Field of Study',
      '70': 'Institute',
      '80': 'Country',
      '90': 'G.P.A',
      '100': 'Year of Study From',
      '110': 'Graduate in Year',
      '120': 'Type of Degree'
    },
    'HRES32EC13': {
      '10': 'Seq.',
      '20': 'Training Course',
      '30': 'Train Date',
      '40': 'Venue',
      '50': 'Organized By',
      '60': 'Data Status'
    },
    'HRES32EC14': {
      '10': 'Training Record',
      '20': 'Seq.',
      '30': 'Training Course',
      '40': 'Train Date',
      '50': 'Venue',
      '60': 'Organized By'
    },
    'HRES32EC15': {
      '10': 'Document',
      '20': 'Seq. No.',
      '30': 'Document Type',
      '40': 'Document Name',
      '50': 'Received Date',
      '60': 'Expire Date',
      '70': 'Doc. No.',
      '80': 'File name',
      '90': 'Remark',
      '100': 'Data Status'
    },
    'HRES32EC16': {
      '10': 'Spouse Tax Deduction',
      '20': 'Tax Exemption',
      '30': 'Item Code',
      '40': 'Description',
      '50': 'Amount',
      '60': 'No. of Childen (Studying)',
      '70': 'Persons',
      '80': 'No. of Childen (Not Studying)',
      '90': 'Persons',
      '100': 'Tax Allowance',
      '110': 'Item Code',
      '120': 'Description',
      '130': 'Amount',
      '140': 'Other Deduction',
      '150': 'Item Code',
      '160': 'Description',
      '170': 'Amount'
    },
    'HRES32EC2': {
      '10': 'Details',
      '20': 'Previous Data',
      '30': 'New Data',
      '40': 'Title',
      '50': 'Name(Thai)',
      '60': 'Last Name(Thai)',
      '70': 'Reason',
      '80': 'Name(Eng)',
      '90': 'Last Name(Eng)',
      '99': 'Request for Personal Data Change'
    },
    'HRES32EC3': {
      '10': 'Personal Data',
      '20': 'Registration Address',
      '30': 'Contact Address',
      '40': 'Address',
      '50': 'District',
      '60': 'Amphur',
      '70': 'Province',
      '80': 'Country',
      '90': 'Post/Zip',
      '100': 'Address',
      '110': 'District',
      '120': 'Amphur',
      '130': 'Province',
      '140': 'Country',
      '150': 'Post/Zip',
      '160': 'Tel. no',
      '170': 'E-mail'
    },
    'HRES32EC4': {
      '10': 'Personal Data(2)',
      '20': 'ID Card',
      '30': 'ID. Card NO.',
      '40': 'Place of Issue',
      '50': 'Province',
      '60': 'Expire Date',
      '70': 'Passport Number',
      '80': 'Expire Date',
      '90': 'Work Permit Number',
      '100': 'Work Permit Issue Date',
      '110': 'Work Permit Expire  Date',
      '120': 'Driving License',
      '130': 'License No.',
      '140': 'Expire Date',
      '150': 'Ohter Status',
      '160': 'Marital Status',
      '170': 'Military Service'
    },
    'HRES32EC5': {
      '10': 'Parents Information',
      '20': 'Father"s Information',
      '30': 'Name',
      '40': 'Nationality',
      '50': 'Relegion',
      '60': 'Occupation',
      '70': 'Citizen i.d',
      '80': 'Mother"s Information',
      '90': 'Name',
      '100': 'Nationality',
      '110': 'Relegion',
      '120': 'Occupation',
      '130': 'Citizen ID',
      '140': 'Emergency Contact Person',
      '150': 'Name',
      '160': 'Address',
      '170': 'Post/Zip',
      '180': 'Tel. No',
      '190': 'Fax.no',
      '200': 'Email-Add.',
      '210': 'Relationship'
    },
    'HRES32EC6': {
      '10': 'Bank Account Information',
      '20': 'Bank Code',
      '30': 'Account No.',
      '40': '% Deposit',
      '50': 'Bank Code',
      '60': 'Account No.',
      '70': '% Deposit'
    },
    'HRES32EC7': {
      '10': 'Employee "s Spouse Data',
      '20': 'Spouse Information',
      '30': 'Registration Information',
      '40': 'Title',
      '41': 'Name',
      '42': 'Last Name',
      '50': 'Citizen ID.',
      '60': 'Birth Date',
      '70': 'Occupation',
      '80': 'Work Place',
      '90': 'Date',
      '100': 'Place of Registration',
      '110': 'City',
      '120': 'Country',
      '130': 'Oths. Information'
    },
    'HRES32EC8': {
      '10': 'Tax Deduction',
      '20': 'Tax Exemption',
      '30': 'Item Code',
      '40': 'Description',
      '50': 'Amount',
      '60': 'No. of Childen (Studying)',
      '70': 'Persons',
      '80': 'No. of Childen (Not Studying)',
      '90': 'Persons',
      '100': 'Tax Allowance',
      '110': 'Item Code',
      '120': 'Description',
      '130': 'Amount',
      '140': 'Other Deduction',
      '150': 'Item Code',
      '160': 'Description',
      '170': 'Amount'
    },
    'HRES32EC9': {
      '10': 'No.',
      '20': 'Edu. Level',
      '30': 'Degree',
      '40': 'Major',
      '50': 'Field of Study',
      '60': 'Institute',
      '70': 'Country',
      '80': 'Data Status'
    },
    'HRPMC2E12': {
      '1': 'Children Data',
      '10': 'Seq.',
      '20': 'Children"s Name',
      '30': 'ID. Card No.',
      '40': 'Birth Date',
      '50': 'Gender',
      '60': 'Educ. Status',
      '70': 'Deduct Benefit',
      '80': 'Last Update Date',
      '90': 'By',
      '500': 'Education Level'
    },
    'HRPMC2E121': {
      '10': 'Detail of Children',
      '20': 'Seq.',
      '30': 'Children"s Name',
      '40': 'ID. Card No.',
      '50': 'Birth Date',
      '60': 'Gender',
      '70': 'Education Status',
      '80': 'Study',
      '90': 'No Study',
      '100': 'Education Level',
      '110': 'Deduction Benefit',
      '120': 'Yes',
      '130': 'No',
      '900': 'Education Level'
    },
    'HRESH7XC1': {
      '10': 'For Employee',
      '20': 'Year',
      '30': 'Class',
      '40': 'Teaching Date',
      '50': 'Start',
      '60': 'End',
      '70': 'Subject Name',
      '80': 'Evaluation',
      '90': 'Prof.  Fee',
      '100': 'Total Fee',
      '110': 'Training Date from',
      '120': 'to'
    }
  },
  'th': {
    'HRES32EC1': {
      '5': 'วันที่ขอตั้งแต่',
      '7': 'ถึง',
      '10': 'วันที่ขอ',
      '20': 'ประเภทการแก้ไข',
      '25': 'ลำดับที่',
      '30': 'สถานะ',
      '40': 'หมายเหตุ',
      '50': 'ผู้อนุมัติล่าสุด',
      '60': 'ชื่อพนักงาน',
      '70': 'ข้อมูลส่วนตัว',
      '80': 'ข้อมูลการศึกษา',
      '90': 'ข้อมูลบุตร',
      '100': 'ข้อมูลคุณความดี',
      '110': 'ข้อมูลการฝึกอบรม',
      '120': 'วันที่ขอ',
      '140': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES32EC10': {
      '10': 'ที่',
      '20': 'ชื่อบุตร',
      '30': 'วันเกิด',
      '40': 'เพศ',
      '50': 'ระดับการศึกษา',
      '60': 'สถานะข้อมูล'
    },
    'HRES32EC11': {
      '10': 'ประเภทคุณความดี',
      '20': 'รายละเอียด',
      '30': 'เอกสารอ้างอิง'
    },
    'HRES32EC12': {
      '10': 'บันทึกแก้ไขข้อมูลการศึกษา',
      '20': 'ลำดับที่',
      '30': 'ระดับการศึกษา',
      '40': 'วุฒิการศึกษา',
      '50': 'คณะ/สาขาวิชา',
      '60': 'สาขาวิชาเอก',
      '70': 'สถาบัน',
      '80': 'ประเทศ',
      '90': 'เกรดเฉลี่ย',
      '100': 'ปีที่เริ่มการศึกษา',
      '110': 'ปีที่จบการศึกษา',
      '120': 'วุฒิการศึกษา'
    },
    'HRES32EC13': {
      '10': 'ลำดับ',
      '20': 'หลักสูตรอบรม',
      '30': 'วันที่ฝึกอบรม',
      '40': 'สถานที่ฝึกอบรม',
      '50': 'จัดโดย',
      '60': 'สถานะข้อมูล'
    },
    'HRES32EC14': {
      '10': 'ข้อมูลการฝึกอบรม',
      '20': 'ลำดับ',
      '30': 'หลักสูตรอบรม',
      '40': 'วันที่ฝึกอบรม',
      '50': 'สถานที่ฝึกอบรม',
      '60': 'จัดโดย'
    },
    'HRES32EC15': {
      '10': 'เอกสารส่วนตัว',
      '20': 'ลำดับ',
      '30': 'ประเภทเอกสาร',
      '40': 'ชื่อเอกสาร',
      '50': 'วันที่รับ',
      '60': 'วันที่หมดอายุ',
      '70': 'เลขที่เอกสาร',
      '80': 'ชื่อไฟล์',
      '90': 'รายละเอียดอื่นๆ',
      '100': 'สถานะข้อมูล'
    },
    'HRES32EC16': {
      '10': 'ลดหย่อนคู่สมรส',
      '20': 'เงินได้ยกเว้นภาษี',
      '30': 'รหัสรายการ',
      '40': 'รายละเอียด',
      '50': 'จำนวนเงิน',
      '60': 'จำนวนบุตรที่กำลังศึกษา',
      '70': 'คน',
      '80': 'จำนวนบุตรที่ไม่ศึกษา',
      '90': 'คน',
      '100': 'ค่าลดหย่อนภาษี',
      '110': 'รหัสรายการ',
      '120': 'รายละเอียด',
      '130': 'จำนวนเงิน',
      '140': 'ส่วนหักอื่น ๆ ',
      '150': 'รหัสรายการ',
      '160': 'รายละเอียด',
      '170': 'จำนวนเงิน'
    },
    'HRES32EC2': {
      '10': 'รายละเอียด',
      '20': 'ข้อมูลเดิม',
      '30': 'ข้อมูลใหม่',
      '40': 'คำนำหน้า',
      '50': 'ชื่อ(ไทย)',
      '60': 'นามสกุล(ไทย)',
      '70': 'เหตุผล',
      '80': 'ชื่อ(อังกฤษ)',
      '90': 'นามสกุล(อังกฤษ)',
      '99': 'คำร้องเรื่อง การเปลี่ยนแปลงข้อมูลพนักงาน'
    },
    'HRES32EC3': {
      '10': 'ข้อมูลส่วนตัว',
      '20': 'ที่อยู่ตามทะเบียนบ้าน',
      '30': 'ที่อยู่ที่ติดต่อได้',
      '40': 'ที่อยู่',
      '50': 'ตำบล',
      '60': 'อำเภอ',
      '70': 'จังหวัด',
      '80': 'ประเทศ',
      '90': 'รหัสไปรษณีย์',
      '100': 'ที่อยู่',
      '110': 'ตำบล',
      '120': 'อำเภอ',
      '130': 'จังหวัด',
      '140': 'ประเทศ',
      '150': 'รหัสไปรษณีย์',
      '160': 'โทรศัพท์',
      '170': 'E-mail'
    },
    'HRES32EC4': {
      '10': 'ข้อมูลส่วนตัว(2)',
      '20': 'บัตรประชาชน',
      '30': 'เลขที่บัตร',
      '40': 'ออกบัตรที่',
      '50': 'จังหวัด',
      '60': 'วันหมดอายุ',
      '70': 'เลขที่พาสปอร์ต',
      '80': 'วันหมดอายุ',
      '90': 'เลขที่ใบอนุญาตทำงาน',
      '100': 'วันที่ออกใบอนุญาต',
      '110': 'วันที่หมดอายุ',
      '120': 'ใบอนุญาตขับขี่',
      '130': 'เลขที่',
      '140': 'วันหมดอายุ',
      '150': 'สถานะอื่นๆ',
      '160': 'สถานภาพสมรส',
      '170': 'สถานะทหาร'
    },
    'HRES32EC5': {
      '10': 'ข้อมูลบิดา-มารดา',
      '20': 'ข้อมูลบิดา',
      '30': 'ชื่อ',
      '40': 'สัญชาติ',
      '50': 'ศาสนา',
      '60': 'อาชีพ',
      '70': 'เลขที่บัตรประชาชนบิดา',
      '80': 'ข้อมูลมารดา',
      '90': 'ชื่อ',
      '100': 'สัญชาติ',
      '110': 'ศาสนา',
      '120': 'อาชีพ',
      '130': 'เลขที่บัตรประชาชนมารดา',
      '140': 'บุคคลที่สามารถติดต่อได้กรณีฉุกเฉิน',
      '150': 'ชื่อ',
      '160': 'ที่อยู่',
      '170': 'รหัสไปรษณีย์',
      '180': 'โทรศัพท์',
      '190': 'แฟกซ์',
      '200': 'อีเมล์',
      '210': 'ความสัมพันธ์'
    },
    'HRES32EC6': {
      '10': 'ข้อมูลธนาคาร',
      '20': 'รหัสธนาคาร',
      '30': 'เลขที่บัญชี',
      '40': '% เข้าบัญชี',
      '50': 'รหัสธนาคาร',
      '60': 'เลขที่บัญชี',
      '70': '% เข้าบัญชี'
    },
    'HRES32EC7': {
      '10': 'ข้อมูลคู่สมรส',
      '20': 'ข้อมูลของคู่สมรส',
      '30': 'ข้อมูลการจดทะเบียน',
      '40': 'คำนำหน้า',
      '41': 'ชื่อ',
      '42': 'นามสกุล',
      '50': 'เลขบัตรประชาชน',
      '60': 'วันเกิด',
      '70': 'อาชีพ',
      '80': 'สถานที่ทำงาน',
      '90': 'วันที่',
      '100': 'สถานที่จดทะเบียน',
      '110': 'จังหวัด',
      '120': 'ประเทศ',
      '130': 'รายละเอียดอื่นๆ'
    },
    'HRES32EC8': {
      '10': 'ลดหย่อนภาษี',
      '20': 'เงินได้ยกเว้นภาษี',
      '30': 'รหัสรายการ',
      '40': 'รายละเอียด',
      '50': 'จำนวนเงิน',
      '60': 'จำนวนบุตรที่กำลังศึกษา',
      '70': 'คน',
      '80': 'จำนวนบุตรที่ไม่ศึกษา',
      '90': 'คน',
      '100': 'ค่าลดหย่อนภาษี',
      '110': 'รหัสรายการ',
      '120': 'รายละเอียด',
      '130': 'จำนวนเงิน',
      '140': 'ส่วนหักอื่น ๆ ',
      '150': 'รหัสรายการ',
      '160': 'รายละเอียด',
      '170': 'จำนวนเงิน'
    },
    'HRES32EC9': {
      '10': 'ที่',
      '20': 'ระดับการศึกษา',
      '30': 'วุฒิการศึกษา',
      '40': 'วิชาเอก',
      '50': 'สาขาการศึกษา',
      '60': 'สถาบันการศึกษา',
      '70': 'ประเทศ',
      '80': 'สถานะข้อมูล'
    },
    'HRPMC2E12': {
      '1': 'ข้อมูลบุตร',
      '10': 'ลำดับ',
      '20': 'ชื่อบุตร',
      '30': 'เลขที่บัตรประชาชน',
      '40': 'วันเกิด',
      '50': 'เพศ',
      '60': 'สถานะการศึกษา',
      '70': 'การลดหย่อนภาษี',
      '80': 'แก้ไขครั้งสุดท้ายเมื่อ',
      '90': 'โดย',
      '500': 'ระดับการศึกษา'
    },
    'HRPMC2E121': {
      '10': 'รายละเอียดของบุตร',
      '20': 'ลำดับ',
      '30': 'ชื่อบุตร/ธิดา',
      '40': 'เลขที่บัตรประชาชน',
      '50': 'วันเกิด',
      '60': 'เพศ',
      '70': 'สถานะการศึกษา',
      '80': 'ศึกษา',
      '90': 'ไม่ศึกษา',
      '100': 'ระดับการศึกษา',
      '110': 'ใช้สิทธิ์ลดหย่อน',
      '120': 'ใช้',
      '130': 'ไม่ใช้',
      '900': 'ระดับการศึกษา'
    },
    'HRESH7XC1': {
      '10': 'สำหรับพนักงาน',
      '20': 'ปี',
      '30': 'รุ่นที่',
      '40': 'วันที่อบรม',
      '50': 'เริ่มต้น',
      '60': 'สิ้นสุด',
      '70': 'ชื่อวิชา',
      '80': 'ผลประเมิน',
      '90': 'อัตราค่าวิชาชีพ',
      '100': 'รวมค่าใช้จ่าย',
      '110': 'วันที่เริ่มอบรม ตั้งแต่',
      '120': 'ถึง'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres32e.js